import React from 'react';
import SimplrDropdown from '../../../DropDown/SimplrDropdown/SimplrDropdown';
import { TICKET_STATUS_FILTER } from '../../../../constants/ticketStatuses';

const ticketStatusOptions = [
  {
    id: TICKET_STATUS_FILTER.all,
    label: 'All',
  },
  {
    id: TICKET_STATUS_FILTER.forwardToExperts,
    label: 'Forward to Experts',
  },
  {
    id: TICKET_STATUS_FILTER.awaitingNomination,
    label: 'Awaiting Nomination',
  },
  {
    id: TICKET_STATUS_FILTER.paused,
    label: 'Paused',
  },
  {
    id: TICKET_STATUS_FILTER.assigned,
    label: 'In Process',
  },
  {
    id: TICKET_STATUS_FILTER.closed,
    label: 'Resolved',
  },
  {
    id: TICKET_STATUS_FILTER.nominated,
    label: 'Nominated',
  },
  {
    id: TICKET_STATUS_FILTER.takenBySMB,
    label: 'Taken by SMB',
  },
  {
    id: TICKET_STATUS_FILTER.unassignedClosed,
    label: 'Unassigned Closed',
  },
  {
    id: TICKET_STATUS_FILTER.new,
    label: 'New',
  },
  {
    id: TICKET_STATUS_FILTER.escalated,
    label: 'Escalated by Experts',
  },
  {
    id: TICKET_STATUS_FILTER.sentback,
    label: 'Sentback',
  },
];

/**
 * TicketStatusFilter - Dropdown for selecting ticket status
 * @param {Object} props
 * @param {string} props.selectedStatus - Currently selected status value
 * @param {Function} props.onSelect - Callback when status is selected
 */
export const TicketStatusFilter = ({ selectedStatus, onSelect }) => {
  return (
    <SimplrDropdown
      selected={selectedStatus}
      options={ticketStatusOptions}
      onSelect={onSelect}
      placeholder="Select status"
    />
  );
};
